import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearToken, getToken } from "../config/enviroment";
import { fetchSignIn } from "../helper/actions/fetchActions/fetchAuth";
import { setAuthorized, setCredentialsAuth, setPermissions, setProfile, setRepresentative, setRepresented } from "../helper/actions/auth";
import LoadingDefault from "../components/LoadingDefault";
import jwtDecode from 'jwt-decode';
import { isAuthenticationExpired } from "../services/simulatedAuthentication";

export default function PrivateRoute({ component: Component, exact, path }) {
  const dispatch = useDispatch();
  const { loading } = useSelector((store) => store.loading);
  const storedAuthentication = getToken();
  let authenticated = null;

  try {
    authenticated = storedAuthentication
      ? JSON.parse(storedAuthentication)
      : null;
  } catch (error) {
    clearToken();
  }

  useEffect(() => {
    if (!authenticated || isAuthenticationExpired(authenticated)) {
       clearToken();
       fetchSignIn();
    } else {
      try {
        const user = jwtDecode(authenticated.access_token);
        dispatch(setCredentialsAuth(authenticated.access_token));
        dispatch(setAuthorized(true));
        dispatch(setPermissions(user.permission));
        dispatch(setProfile(user.profile));
        dispatch(
          setRepresentative({
            name: user.name_representative,
            documentNumber: user.cpf_cnpj_representative,
          })
        );
        dispatch(
          setRepresented({
            name: user.name_represented,
            documentNumber: user.cpf_cnpj,
            documentType: user.document_type,
          })
          );
      } catch (error) {
        clearToken();
        fetchSignIn();
      }
    }
  }, []); // eslint-disable-line

  if (loading) return <LoadingDefault typeLoading="card" />;

  return <Route exact={exact} path={path} render={(props) => <Component {...props} />} />;
}
